import axios from "axios";

const service = axios.create({
  baseURL: `https://localhost:44358/`,
});

/**
 * Hàm chung gọi api sang phía transaction
 * @param {String} url
 * @param {AxiosRequestConfig} configRequest bao gồm method, params(GET), data(POST,PUT), headers...
 * CreateBy: PVPhong (16/04/2021)
 */
export const CallService = (url, configRequest) => {
  return new Promise((reslove, reject) => {
    service(url, configRequest)
      .then((res) => reslove(res))
      .catch((err) => reject(err.response));
  });
};
